import Autocomplete from '@mui/material/Autocomplete'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import TextField from '@mui/material/TextField'
import i18n from '../../lang/idiomas'

import { ClickAwayListener, Slide } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getArticulos } from '../../actions/articulos'
import { getPedidoActivo } from '../../actions/pedidos'
import { getPrecios } from '../../actions/precios'
import { setCustomer } from '../../actions/selectorCliente'
let optionsClientes = []

const SelectorClienteBuscador = () => {
  const dispatch = useDispatch()

  const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
  const ecomClientesPermitidos = useSelector(state => state.auth.user.clientes_permitidos)
  const usuario = useSelector(state => state.auth.user)
  const clienteSeleccionado = useSelector(state => state.selectorCliente.cliente_seleccionado)
  const id_pedido_seleccionado = useSelector(state => state.pedidos.id_pedido_seleccionado)
  const hash = useSelector(state => state.auth.hash)
  const articulos = useSelector(state => state.listadoArticulos.articulos)
  const [value, setValue] = useState(optionsClientes[0])
  const [anchorEl, setAnchorEl] = useState(null)
  const [clienteCambiando, setClienteCambiando] = useState(false)

  const handleClick = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popper' : undefined

  useEffect(() => {
    if (value?.value === usuario.id) sessionStorage.setItem('h_pers', '')
    else value?.value && sessionStorage.setItem('h_pers', value?.value)
    dispatch(setCustomer(value?.value))
    dispatch(getPedidoActivo(hash != null ? hash : '', 'S', id_pedido_seleccionado))
    if (value) {
      setClienteCambiando(true)
    }
    dispatch(getArticulos())
  }, [value])

  useEffect(() => {
    if (articulos && clienteCambiando) {
      let articulos_aux = []
      for (let actual of articulos.articulos) {
        articulos_aux.push({
          codigo_articulo: actual.codigo_articulo,
          cantidad: actual.cantidad_minima ? Number(actual.cantidad_minima) : 1,
          presentacion: actual.presentacion_web,
        })
      }

      if (articulos_aux.length > 0) {
        dispatch(getPrecios(articulos_aux, 'selectorclientebuscador', null))
      }

      setClienteCambiando(false)
    }
  }, [articulos])

  useEffect(() => {
    if (
      isAuthenticated &&
      ecomClientesPermitidos &&
      ecomClientesPermitidos.length > 0 &&
      optionsClientes.length === 0
    ) {
      ecomClientesPermitidos.forEach(cliente =>
        optionsClientes.push({
          key: cliente.id,
          label:
            cliente?.principal === 'S'
              ? i18n.t('usuarios.selcli')
              : cliente.codigo_cliente + ' - ' + cliente.nombre,
          value: cliente.id,
          codigo_cliente: cliente.codigo_cliente,
        }),
      )

      let clienteSessionStorage = optionsClientes.find(
        cliente => cliente?.value == sessionStorage.getItem('h_pers'),
      )

      if (clienteSessionStorage) {
        setValue(clienteSessionStorage)
      } else {
        if (
          (clienteSeleccionado === null || clienteSeleccionado === '') &&
          usuario.codigo_cliente !== ''
        ) {
          let clientePredeterminado = optionsClientes.find(
            cliente => cliente.codigo_cliente === usuario.codigo_cliente,
          )
          setValue(clientePredeterminado)
        }
      }
    }
  }, [optionsClientes])

  return ecomClientesPermitidos !== undefined &&
    (ecomClientesPermitidos.length > 1 ||
      (ecomClientesPermitidos.length === 1 && ecomClientesPermitidos[0].id !== usuario.id)) ? (
    <>
      <Button
        sx={{ color: 'black' }}
        onClick={handleClick}>
        {value?.label || i18n.t('usuarios.selcli')}
      </Button>
      <Popper
        sx={{ zIndex: '9999999999' }}
        id={id}
        open={open}
        anchorEl={anchorEl}>
        <ClickAwayListener onClickAway={handleClick}>
          <Slide in={open}>
            <Paper
              sx={{
                marginTop: '1rem',
                marginRight: '2rem',
                width: 500,
                backgroundColor: '#eee!important',
                borderBottomLeftRadius: '7px',
              }}>
              <Autocomplete
                disablePortal
                id='combo-box-demo'
                options={optionsClientes}
                onChange={(event, newValue, reason) => {
                  setValue(newValue)
                  handleClick()
                }}
                disableClearable={true}
                sx={{}}
                renderInput={params => (
                  <TextField
                    {...params}
                    label={i18n.t('usuarios.selcli')}
                  />
                )}
              />
            </Paper>
          </Slide>
        </ClickAwayListener>
      </Popper>
    </>
  ) : null
}

export default SelectorClienteBuscador
